import { render, staticRenderFns } from "./MVPTable.vue?vue&type=template&id=16643c12"
import script from "./MVPTable.vue?vue&type=script&lang=js"
export * from "./MVPTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports